import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { SQLiteObject } from '@ionic-native/sqlite';
import { DatabaseProvider } from '../database/database';

@Injectable()
export class EmpresaProvider {


  constructor(public dbProvider: DatabaseProvider) {

  }

  async insert(data) {
    this.dbProvider.getDB()
    .then((db: SQLiteObject) => {  
      db.transaction(async (tx) => {
        let sql = 'insert into empresas(Emp_Numero, Emp_RazaoSocial, Emp_NomeFantasia, Emp_CNPJ, Emp_Cidade, Emp_UF) values (?, ?, ?, ?, ?, ?)';
        for (let val of data){
          let empresa = new Empresa();
          empresa.codigo = val.Emp_ID;
          empresa.razaosocial = val.Emp_RazaoSocial;
          empresa.nomefantasia = val.Emp_NomeFantasia;
          empresa.cnpj = val.Emp_CNPJ;
          empresa.cidade = val.Emp_Cidade;
          empresa.uf = val.Emp_UF;

          let params = [empresa.codigo, empresa.razaosocial, empresa.nomefantasia, empresa.cnpj, empresa.cidade, empresa.uf];
  
          await tx.executeSql(sql, params, (tx, resultSet) => {
            console.log('importou empresa');
          }, (err) => {
            console.log('erro:' + err); 
          });  

        }    
      }).then();

    })
    .catch((e) => console.error(e));
  }

  public removeAll() {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'delete from empresas';
        let data = [];

        return db.executeSql(sql, data)
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }

  public get() {
    return this.dbProvider.getDB()
    .then((db: SQLiteObject) => {
      let sql = 'SELECT * FROM empresas';
      
      return db.executeSql(sql, [])
        .then((data: any) => {
          if (data.rows.length > 0) {
            let empresa = new Empresa();
            empresa.codigo = data.rows.item(0).Emp_Numero;
            empresa.razaosocial = data.rows.item(0).Emp_RazaoSocial;
            empresa.nomefantasia = data.rows.item(0).Emp_NomeFantasia;
            empresa.cnpj = data.rows.item(0).Emp_CNPJ;
            empresa.uf = data.rows.item(0).Emp_UF;
            empresa.cidade = data.rows.item(0).Emp_Cidade;
            return empresa;
          } else {
            return new Empresa();
          }
        })
        .catch((e) => console.error(e));
    })
    .catch((e) => console.error(e));
  }
}

export class Empresa {
  codigo: number;
  razaosocial: string;
  nomefantasia: string;
  cnpj: string;
  uf: string;
  cidade: string;
}


// WEBPACK FOOTER //
// ./src/providers/empresa/empresa.ts